module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_64-21a51814b33fe2c605b94f6c6c0e2496.png";